import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * finalize appointment superbill
 */
export default async function finalizeSuperbill(
  statement_no: string | number,
  statement_revision: string | number,
) {
  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/superbill/appointment/finalize/${statement_no}/${statement_revision}`,
    {
      method: "POST",
    },
  );
  if (!response.ok) {
    throw new Error(getErrorDetail(await response.text()));
  }
}
